export default {
  setFilters: (state, filters) => {
    state.filters = filters;
  },

  setPaginationOptions: (state, paginationOptions) => {
    state.paginationOptions = paginationOptions;
  },

  retrievedNotifications: (state, notifications) => {
    state.notifications = notifications;
  },
  setCurrentPage(state, data) {
    state.notifications.meta.current_page = data;
  }
};
